<template>
  <div class="team">
    <div class="tame">{{ team.name }}</div>
    <div class="owner">{{ team.owner }}</div>
    <table>
      <tr>
        <th>Player</th>
        <th>Target</th>
        <th>HR</th>
        <th>DP</th>
        <th>PDP</th>
        <th>TPA</th>
        <th>Games</th>
      </tr>
      <tr v-for="(player, index) in team.players" :key="index">
          <td>{{ player.name }}</td>
          <td>{{ player.target }}</td>
          <td>{{ player.hr }}</td>
          <td>{{ player.points }}</td>
          <td>{{ player.projectedPoints }}</td>
          <td>{{ player.plateAppearances }}</td>
          <td>{{ player.games }}</td>
      </tr>
      <tr class="total">
        <td>&nbsp;</td>
        <td>{{ team.target }}</td>
        <td>{{ team.hr }}</td>
        <td>{{ team.points }}</td>
        <td>{{ team.projectedPoints }}</td>
        <td>{{ team.plateAppearances }}</td>
        <td>{{ team.games }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Team',
  props: {
    team: Object
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

tr.total {
  color: #42b983;
}
div.name {
  font-weight: bold;
}
div.owner {
   text-align: left;
}
</style>
